function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { SplitContext } from "@splitsoftware/splitio-react";
import { useContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import featureFlags from "../constants/feature-flags.json";
var useAppSelector = useSelector;
export var FEATURE_FLAGS = featureFlags;
export var useFeatureToggle = function(flagName) {
    var isMock = import.meta.env.MODE !== "production" || import.meta.env.VITE_MOCK;
    var _useContext = useContext(SplitContext), factory = _useContext.factory, isReady = _useContext.isReady;
    var accountId = useAppSelector(function(param) {
        var auth = param.auth;
        return auth;
    }).accountId;
    var client = useMemo(function() {
        return factory === null || factory === void 0 ? void 0 : factory.client(accountId || localStorage.getItem("vch.account_id") || "key");
    }, [
        accountId,
        factory
    ]);
    var _useState = _sliced_to_array(useState(), 2), isFeatureOn = _useState[0], setIsFeatureOn = _useState[1];
    useEffect(function() {
        if (isMock) return;
        var timeout;
        if (isReady) {
            setIsFeatureOn((client === null || client === void 0 ? void 0 : client.getTreatment(flagName)) === "on");
        } else {
            timeout = setTimeout(function() {
                if (!isReady) {
                    setIsFeatureOn(false);
                }
            }, 5000);
        }
        return function() {
            timeout && clearTimeout(timeout);
        };
    }, [
        client,
        flagName,
        isMock,
        isReady
    ]);
    // In development and test envs all treatments are on. Fine for now.
    if (isMock) {
        return [
            true
        ];
    }
    return [
        isFeatureOn
    ];
};

//# sourceMappingURL=useFeatureToggle.js.map